import React, {useRef, useState} from "react";
import {
    Box,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow, MenuItem,
    MenuList,
    Paper,
    Popper,
    Tooltip
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import DataUpdateCountBadge from "./DataUpdateCountBadge";
import { Views } from "react-big-calendar";

export default function AvailabilityActionsPanel({onRefresh, isLoading, onEnrollAll, onUnenrollAll, currentView}) {
    
    const containerStyle = {display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '0.2rem', zIndex: 100};
    const iconButtonStyle = {margin: '0.1rem', minHeight: '2rem', minWidth: '0', padding: '0 0.5rem', '& .MuiButton-endIcon': {margin: 0}};
    
    const enrollmentOptions = ['All Available', 'Remove All'];
    const enrollmentOptionTooltips = ['Enroll in all available shifts for this week', 'Remove enrollments for all shifts for this week'];
    
    const [openEnrollmentMenu, setOpenEnrollmentMenu] = useState(false);
    const [selectedEnrollmentOption, setSelectedEnrollmentOption] = useState(0);
    const enrollmentOptionAnchorRef = useRef(null);

    const handleEnrollmentOptionToggle = () => setOpenEnrollmentMenu(prevOpen => !prevOpen);
    const handleEnrollmentOptionClick = () => selectedEnrollmentOption === 0 ? onEnrollAll() : onUnenrollAll();

    const handleEnrollmentOptionGroupItemClick = (event, index) => {
        setSelectedEnrollmentOption(index);
        setOpenEnrollmentMenu(false);
    };

    const handleEnrollmentOptionGroupClose = (event) => {
        if (enrollmentOptionAnchorRef.current && enrollmentOptionAnchorRef.current.contains(event.target)) {
            return;
        }
        
        setOpenEnrollmentMenu(false);
    };

    return (
        <>
            <Box style={containerStyle}>
                <DataUpdateCountBadge />

                <Button variant='contained' size='small' sx={iconButtonStyle} onClick={onRefresh} disabled={isLoading} endIcon={<RefreshIcon />} />

                {currentView === Views.WEEK && (
                    <ButtonGroup variant="contained" ref={enrollmentOptionAnchorRef} size="small" sx={{ margin: '0.1rem', minHeight: '2rem' }} disabled={isLoading}>
                        <Tooltip title={enrollmentOptionTooltips[selectedEnrollmentOption]}>
                            <Box>
                                <Button onClick={handleEnrollmentOptionClick} sx={{ width: '8rem', height: '2rem' }}>{enrollmentOptions[selectedEnrollmentOption]}</Button>
                            </Box>
                        </Tooltip>
                        <Button onClick={handleEnrollmentOptionToggle}><ArrowDropDownIcon /></Button>
                        <Popper open={openEnrollmentMenu} sx={{ zIndex: 10000 }} anchorEl={enrollmentOptionAnchorRef.current} transition>
                            {({ TransitionProps }) => (
                                <Grow {...TransitionProps}>
                                    <Paper>
                                        <ClickAwayListener onClickAway={handleEnrollmentOptionGroupClose}>
                                            <MenuList autoFocusItem>
                                                {
                                                    enrollmentOptions.map((option, index) => (
                                                        <MenuItem
                                                            key={index}
                                                            selected={index === selectedEnrollmentOption}
                                                            onClick={event => handleEnrollmentOptionGroupItemClick(event, index)}>
                                                            {option}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </MenuList>
                                        </ClickAwayListener>
                                    </Paper>
                                </Grow>
                            )}
                        </Popper>
                    </ButtonGroup>
                )}
            </Box>
        </>
    );
}